import GenericDropdown from './GenericDropdown'

export default GenericDropdown
